
import { SupportedLanguage } from "@/components/multilingual/LanguageSelector";
import { LANGUAGE_COOKIE_NAME } from "./types";

export const defaultLanguage: SupportedLanguage = 'en';

// Function to detect browser language
export const detectBrowserLanguage = (): SupportedLanguage => {
  const browserLang = navigator.language.split('-')[0];
  if (['en', 'de', 'fr', 'es'].includes(browserLang)) {
    return browserLang as SupportedLanguage;
  }
  return defaultLanguage;
};

// Function to get the user's preferred language
export const getUserLanguage = (): SupportedLanguage => {
  const savedLanguage = localStorage.getItem(LANGUAGE_COOKIE_NAME);
  if (savedLanguage && ['en', 'de', 'fr', 'es'].includes(savedLanguage)) {
    return savedLanguage as SupportedLanguage;
  }
  return detectBrowserLanguage();
};

// Function to save the user's language preference
export const saveUserLanguage = (language: SupportedLanguage): void => {
  localStorage.setItem(LANGUAGE_COOKIE_NAME, language);
};
